<template>
  <div>
    <script type="application/ld+json">
      {
        "@context": "http://schema.org",
        "@graph": [
          {
            "@type": "Article",
            "url": "https://www.teddi.co/terms/",
            "headline": "Conditions générales d'utilisation ← Teddi",
            "description": "L'utilisation de la plateforme Teddi nécessite la création d'un compte en ligne, vous êtes responsables de l'information personnelle que vous fournissez.",
            "datePublished": "2020-04-10T17:47:50.000Z",
            "dateModified": "2019-04-11T09:20:51.000Z",
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": "https://www.teddi.co/terms/"
            },
            "publisher": {
              "@type": "Organization",
              "@id": "https://www.teddi.co/",
              "name": "Teddi",
              "logo": {
                "@type": "ImageObject",
                "url": "https://www.teddi.co/assets/socials/fb-profile.png",
                "width": 1000,
                "height": 1000
              }
            },
            "author": {
              "@type": "Person",
              "name": "Teddi"
            }
          }
        ]
      }
    </script>
    <div class="container py-5">
      <div class="row">
        <div class="col-md-6 mx-auto">
          <h1>Conditions générales d’utilisation et de vente (CGUV)</h1>
          <h2>Présentation générale</h2>         
          <h2>ARTICLE 1 – Définitions</h2>
          <p>Dans les présentes Conditions Générales :</p>
          <p>
            « Add-on » désigne les services additionnels payants proposés, le cas échéant, en sus de
            l'abonnement principal ;
          </p>
          <p>
            « Conditions Générales » ou « CGUV » désignent les conditions générales d’utilisation du
            Site ainsi que les conditions générales de vente qui régissent l’ensemble des relations
            contractuelles entre Teddi et le Membre dans le cadre du Service ;
          </p>
          <p>
            « Cookie » désigne un petit fichier d'informations qu'un site Web peut envoyer sur le
            disque dur d'un ordinateur personnel pour ensuite en retrouver la trace.
          </p>
          <p>
            « Identifiants » désignent la combinaison d'un login et d'un mot de passe permettant au
            Membre d'accéder aux Services proposés par Teddi ;
          </p>
          <p>
            « Internet » désigne l’ensemble de réseaux informatiques et de télécommunications
            interconnectés, de dimension mondiale, communicant via des serveurs à l’aide de
            protocoles spécifiques, à destination de tout équipement terminal, présent ou à venir,
            connecté directement ou indirectement à un point de terminaison des réseaux précités, en
            vue de la transmission, du traitement ou de la réception d’informations ;
          </p>
          <p>
            « Membre » désigne tout utilisateur du Site ayant souscrit un compte gratuit auprès de
            Teddi en vue de l’utilisation du Service ;
          </p>
          <p>« Parties » désigne ensemble Teddi et le Membre.</p>
          <p>
            « Service » désigne l’ensemble des prestations proposées par Teddi par l’intermédiaire
            du Site ;
          </p>
          <p>
            « Site » désigne le site Internet créé, développé et exploité par Teddi accessible à
            l'adresse
            <a href="https://www.teddi.co/">https://www.teddi.co</a> ;
          </p>
          <p>
            Les termes définis aux présentes auront la même signification qu’ils soient utilisés au
            singulier ou au pluriel, au féminin ou au masculin.
          </p>
          <h2>ARTICLE 2 – Objet des Conditions Générales</h2>
          <p>
            Les présentes Conditions Générales ont pour objet de régir l’utilisation qui sera faite
            par le Membre des fonctionnalités du Site et de régir tout contrat en ligne conclu entre
            Teddi et le Membre.
          </p>
          <h2>ARTICLE 3 – Généralités</h2>
          <p>
            3.1 – Les présentes Conditions Générales sont valables à compter du 1er mars 2020.
          </p>
          <p>
            3.2 - Le Membre déclare être majeur et avoir la capacité juridique pour utiliser les
            services du Site et contracter.
          </p>
          <p>
            3.3 – Le Membre s’engage, lors de chacune de ses visites sur le Site, à lire, comprendre
            et respecter l’intégralité des Conditions Générales, lesquelles s’appliquent à
            l’ensemble du Service. En conséquence et du seul fait de son accès au Site, le Membre
            accepte, pleinement et sans réserve, les présentes Conditions Générales.
          </p>
          <p>
            3.4 – Les Conditions Générales prévalent sur tout document contractuel ou non
            contractuel propre au Membre. Elles expriment l'intégralité de l'accord intervenu entre
            Teddi et le Membre.
          </p>
          <p>
            Teddi se réserve le droit de modifier à tout moment, à sa seule discrétion, les
            présentes Conditions Générales en publiant une nouvelle version sur le Site. Les
            nouvelles Conditions Générales seront adressées au Membre par courrier électronique à
            l'adresse renseignée par le Membre lors de son inscription.
          </p>
          <p>
            3.5 – Les présentes Conditions Générales sont la propriété de Teddi. En conséquence et
            sans que cette liste ne soit limitative, toute diffusion, exploitation, représentation,
            reproduction ou utilisation, totale ou partielle, sur tout support, des présentes
            Conditions Générales à des fins autres que strictement personnelles et non
            professionnelles, est soumise à l'autorisation préalable de Teddi. A défaut de cette
            autorisation, le contrevenant s'expose aux incriminations et aux poursuites pénales et
            civiles prévues par la loi.
          </p>
          <p>
            3.6 - Dans l’hypothèse où le Membre agit en tant que professionnel, il ne bénéficie pas
            des dispositions protectrices du Code de la consommation qui sont uniquement applicables
            au Membre consommateur.
          </p>
          <h2>ARTICLE 4 – Usage du Service</h2>
          <p>4.1 – Condition d’accès au service</p>
          <p>
            Afin d’utiliser le Site et d’accéder au contenu, vous devez (1) être âgé d’au moins 18
            ans, ou être âgé d’au moins 13 ans et disposer de l’accord de votre parent ou tuteur
            concernant les contrats, (2) avoir la capacité de conclure un contrat ayant force
            exécutoire avec nous et ne pas être interdit de le faire en vertu de toute législation
            applicable, et (3) être résident d’un pays où le Site est disponible. Vous vous engagez
            également à ce que toute information d’inscription que vous transmettez à Teddi soit
            exacte, fidèle et exhaustive, et vous convenez de faire en sorte que cela soit le cas à
            tout moment.
          </p>
          <p>4.2 – Processus de d'inscription</p>
          <p>
            Une fois enregistré, le Membre a accès aux fontionnalités proposées par Teddi.
          </p>
          <p>
            Une fois le paiement validé, Teddi adresse une confirmation d'inscription au Membre, par
            courrier électronique.
          </p>
          <p>
            Si le Membre n’a pas reçu cet e-mail de confirmation, il est invité à consulter les «
            spams » de sa boîte aux lettres électronique. Si cet e-mail ne figure pas dans les «
            spams », le Membre est invité à contacter Teddi par courrier électronique à l’adresse :
            hello@teddi.co
          </p>
          <p>4.3 – Conditions d’annulation</p>
          <p>
            4.3.1 – Les abonnements toutes annulables à tout moment. En cas d'annulation à votre
            initiative, Teddi cessera de vous facturer dès la date de résiliation et vous
            remboursera tous les frais payés pour la période postérieure à la résiliation. Si vous
            avez déjà été facturé pour le mois courant, vous serez remboursé au pro rata du temps
            non utilisé jusqu'au moment où vous avez pris l'initiative d'annuler votre abonnement.
          </p>
          <h2>ARTICLE 5 – Prix</h2>
          <p>L’utilisation du Site est payant pour ses Membres.</p>
          <p>
            L'utilisation des fonctionnalités du Site est payante pour le Membre. Les prix sont
            indiqués en euros. Ils ne comprennent pas la T.V.A., conformément au taux en vigueur
            pour le service concerné. Le prix d’une Offre peut être modifié à tout moment.
            Toutefois, le tarif appliqué à une Offre sera celui annoncé sur le Site au moment de
            l'inscription.
          </p>
          <p>
            De temps à autre, nous ou des tiers en notre nom pouvons offrir des essais d’Abonnements
            payants pendant une période spécifiée, sans paiement, ou à un prix réduit (un « Essai
            »). Teddi se réserve le droit, à son entière discrétion, de déterminer votre éligibilité
            à un Essai, et, sous réserve de la législation applicable, de retirer ou de modifier un
            Essai à tout moment, sans préavis ni aucune responsabilité, dans la plus large mesure
            autorisée par la loi. Pour certains Essais, nous vous demanderons de fournir vos
            informations bancaires afin de démarrer l’Essai. À LA FIN DE CES ESSAIS, NOUS POUVONS
            AUTOMATIQUEMENT COMMENCER À VOUS FACTURER L’ABONNEMENT PAYANT APPLICABLE LE PREMIER JOUR
            SUIVANT LA FIN DE L’ESSAI, ET CE DE MANIÈRE MENSUELLE RÉCURRENTE. EN FOURNISSANT VOS
            INFORMATIONS BANCAIRES EN CONJONCTION AVEC L’ESSAI, VOUS ACCEPTEZ CETTE FACTURATION EN
            UTILISANT CES DÉTAILS DE PAIEMENT. SI VOUS NE VOULEZ PAS CETTE FACTURATION, VOUS DEVEZ
            ANNULER L’ABONNEMENT PAYANT CONCERNÉ PAR L’INTERMÉDIAIRE DE LA PAGE ABONNEMENT DE VOTRE
            COMPTE TEDDI OU RÉSILIER VOTRE COMPTE TEDDI AVANT LA FIN DE L’ESSAI. SI VOUS NE VOULEZ
            PAS CONTINUER À ÊTRE FACTURÉ DE MANIÈRE MENSUELLE RÉCURRENTE, VOUS DEVEZ ANNULER
            L’ABONNEMENT PAYANT CONCERNÉ PAR L’INTERMÉDIAIRE DE LA PAGE ABONNEMENT DE VOTRE COMPTE
            TEDDI OU RÉSILIER VOTRE COMPTE TEDDI AVANT LA FIN DE LA PÉRIODE MENSUELLE RÉCURRENTE.
            LES ABONNEMENTS PAYANTS NE PEUVENT ÊTRE RÉSILIÉS AVANT LA FIN DE LA PÉRIODE POUR
            LAQUELLE VOUS AVEZ DÉJÀ PAYÉ, ET SAUF STIPULATION EXPRESSE CONTRAIRE DES PRÉSENTES
            CONDITIONS, TEDDI NE REMBOURSERA AUCUNS FRAIS QUE VOUS AVEZ DÉJÀ PAYÉS. LA SECTION
            LIMITATION DÉFINIT DES CONDITIONS SUPPLÉMENTAIRES CONCERNANT L’ANNULATION DE VOTRE
            ABONNEMENT PAYANT.
          </p>
          <h2>ARTICLE 6 – Paiement en ligne</h2>
          <p>
            Pour des raisons de sécurité, tous les paiements effectués sur le Site sont réalisés par
            carte bancaire par l’intermédiaire du prestataire de service de paiement Stripe (<a
              href="https://stripe.com/"
              >https://stripe.com</a
            >).
          </p>
          <p>
            Pour utiliser les services de Stripe, le Membre doit préalablement lire, comprendre et
            accepter les conditions générales d’utilisation de Stripe (<a
              href="https://stripe.com/fr/legal"
              >https://stripe.com/fr/legal</a
            >).
          </p>
          <p>
            Stripe utilise le protocole SSL (Secure Socket Layer) de telle sorte que les
            informations transmises sont cryptées par un logiciel dans les règles de l’art et
            qu’aucun tiers ne peut en prendre connaissance au cours du transport sur le réseau.
          </p>
          <p>
            Conformément à l’ARTICLE L. 132-2 du Code monétaire et financier, l’engagement de payer
            donné par carte est irrévocable. Une fois le paiement lancé par le Membre, la
            transaction est immédiatement débitée après vérification des informations. En cas
            d’erreur, ou d’impossibilité de débiter la carte, la vente est immédiatement résolue de
            plein droit et la Réservation annulée. Le Membre reconnaît expressément que la
            communication de son numéro de carte bancaire à Stripe vaut autorisation de débit de son
            compte à concurrence des produits commandés. Les données enregistrées et conservées par
            le Site constituent la preuve de la commande et de l’ensemble des transactions passées.
            Les données enregistrées par Stripe constituent la preuve des transactions financières.
            L’éditeur du Site ne pourra en aucun cas être tenu responsable des conséquences d’une
            mauvaise utilisation du site Stripe.com de sa part, ni de l’inaccessibilité de ce site,
            le cas échéant.
          </p>
          <h2>ARTICLE 7 – Propriété du Site</h2>
          <p>
            7.1 –À l'exception des informations, photographies, articles et marques diffusés sur le
            Site qui ne seraient pas la propriété de Teddi, l'ensemble des éléments constituant le
            Site (textes, graphismes, logiciels, photographies, images, vidéos, sons, plans, noms,
            logos, marques, créations et œuvres protégeables diverses, bases de données, etc.) ainsi
            que le Site lui-même, relèvent, notamment, des législations françaises et
            internationales sur le droit d'auteur, sur les droits voisins du droit d'auteur et sur
            le droit des marques.
          </p>
          <p>
            Ces éléments sont la propriété exclusive de Teddi, hormis les éléments réalisés par des
            intervenants extérieurs n'ayant pas cédé leurs droits d'auteur.
          </p>
          <p>
            En conséquence, le Membre s'engage, notamment, à ne pas : reproduire en nombre, à des
            fins commerciales ou non, des informations présentes sur le Site ; intégrer tout ou
            partie du contenu du Site dans un site tiers, à des fins commerciales ou non, excepté en
            cas d'autorisation expresse et préalable de Teddi ; utiliser un robot, notamment
            d'exploration (« spider »), une application de recherche ou récupération de sites
            Internet ou tout autre moyen permettant de récupérer ou d'indexer tout ou partie du
            contenu du Site, excepté en cas d'autorisation expresse et préalable de Teddi ; et
            copier les informations sur des supports de toute nature permettant de reconstituer tout
            ou partie des fichiers d'origine.
          </p>
          <p>
            Le Membre s’oblige, par ailleurs, à prendre toutes les mesures nécessaires, notamment de
            sécurité, à l’égard de son personnel comme de tout tiers sur ses sites pour assurer le
            respect du droit de propriété de Teddi sur le Site.
          </p>
          <p>
            7.2 – Toute utilisation non expressément autorisée d'éléments du Site est susceptible de
            constituer une violation des droits d'auteur, des droits des marques, des droits à
            l'image, des droits des personnes ou de tous autres droits et réglementations en
            vigueur. Elle peut donc engager la responsabilité civile et/ou pénale de son auteur.
          </p>
          <p>
            A cet égard, Teddi se réserve la possibilité de saisir toutes voies de droit à
            l'encontre des personnes qui n'auraient pas respecté les interdictions contenues dans le
            présent article.
          </p>
          <p>
            7.3 - Par dérogation à ce qui précède, Teddi pourra autoriser tout Membre à intégrer,
            dans un site de liaison, un ou plusieurs liens hypertextes vers le Site, à la condition
            que cette utilisation soit effectuée à des fins non commerciales, en conformité avec les
            dispositions légales et/ou réglementaires en vigueur et sans atteinte à l'honneur et à
            la réputation de Teddi. Teddi se réserve le droit de prendre toute mesure appropriée
            pour supprimer des liens non autorisés et, en tout état de cause, de retirer
            l'autorisation de lien à tout moment et sans préavis.
          </p>
          <p>
            7.4 - Le Membre peut être amené à contribuer à enrichir le contenu du Site.
          </p>
          <p>
            Dans cette hypothèse, le Membre autorise Teddi, à titre non exclusif, pour le monde
            entier et pour toute la durée des droits de propriété intellectuelle, à reproduire,
            représenter, exploiter, traduire et/ou adapter ses contributions volontairement
            envoyées.
          </p>
          <h2>ARTICLE 8 – Données personnelles et Cookies</h2>
          <p>8.1 – Données personnelles.</p>
          <p>
            Les données personnelles des Membres collectées sur le Site font l’objet d’un traitement
            par Teddi, pour les finalités suivantes : gestion du Site, gestion des inscriptions et
            créations de comptes, fourniture du Service, gestion de la relation contractuelle.
          </p>
          <p>
            Les informations devant être fournies de façon obligatoire sont identifiées en tant que
            telles sur le formulaire d’inscription. A défaut de fournir ces informations,
            l’utilisateur ne pourra pas s’inscrire en tant que Membre.
          </p>
          <p>
            Les données personnelles traitées pourront être communiquées aux sous-traitants de
            Teddi, aux organismes financiers, à toute entreprise liée à Teddi dans le cadre de
            l’édition et de l’administration du Site, aux autorités administratives et judiciaires,
            aux avocats et conseils de Teddi et à toute personne intervenant dans le cadre d’un
            audit de Teddi, le cas échéant.
          </p>
          <p>
            Le Membre bénéficie à tout moment d’un droit d’accès, d’un droit à la portabilité des
            données, d’un droit de rectification, d’un droit de demander l’effacement des données,
            d’un droit de limitation et d’un droit d’opposition des informations qui le concernent,
            qu'il peut exercer en adressant un mail à Teddi à l’adresse suivante : hello@teddi.co,
            ou un courrier postal à 9 rue des Colonnes, 75002, Paris sous réserve de
            justifier de son identité.
          </p>
          <p>
            En tout état de cause, pour tout complément d’information quant à la collecte et à
            l’utilisation des données personnelles, le Membre est invité à consulter la Politique de
            confidentialité de Teddi accessible en cliquant sur le lien suivant
            <a href="https://www.teddi.co/privacy">https://www.teddi.co/privacy</a>
          </p>
          <p>8.2 – Cookies.</p>
          <p>
            Afin d'améliorer et de personnaliser le Service, Teddi utilise des Cookies destinés à
            signaler le passage d'un utilisateur sur le Site et à lui en rendre l'utilisation plus
            agréable. L’utilisation des Cookies requièrent l'acceptation par l'utilisateur de ces
            Cookies.
          </p>
          <p>
            Les options du navigateur utilisé par le Membre lui permettent de s'informer de la
            présence de Cookies et éventuellement de les refuser. Si le navigateur de l'ordinateur
            personnel de l'utilisateur est configuré pour les refuser, l'accès à ces services peut
            se révéler altéré, voire impossible
          </p>
          <p>
            Les Cookies utilisés sur le Site permettent également d'identifier les services et
            rubriques que l'utilisateur a visités, et plus généralement son comportement en matière
            de visites. Ces informations sont utiles pour mieux personnaliser les services,
            contenus, offres promotionnelles et bannières qui apparaissent sur le Site.
            L'utilisateur peut désactiver les Cookies ou les supprimer en utilisant les options de
            son navigateur. Chaque navigateur étant différent, l'utilisateur est invité à consulter
            la notice de son navigateur pour le paramétrer à sa convenance.
          </p>
          <p>
            La durée de conservation de ces informations dans l'ordinateur de l'utilisateur est de
            douze (12) mois à compter de leur placement ;
          </p>
          <h2>ARTICLE 9 – Responsabilité</h2>
          <p>9.1 – Responsabilité de Teddi</p>
          <p>9.1.1 – Généralités.</p>
          <p>
            Teddi s'engage à exécuter les obligations à sa charge avec tout le soin en usage dans sa
            profession et à se conformer aux règles de l'art. Teddi pourra avoir recours à des
            sous-traitants de son choix pour la réalisation du Service et demeurera seule
            responsable vis-à-vis du Membre de l’exécution de ses obligations. Teddi sera en toute
            hypothèse tenue par une obligation de moyens et non de résultat.
          </p>
          <p>9.1.2 – Limitation de responsabilité.</p>
          <p>
            Teddi ne saurait être tenue responsable d’une quelconque inexécution ou mauvaise
            exécution de la réservation de l’Offre imputable soit au Membre, soit au fait,
            imprévisible et insurmontable, d'un tiers, soit à un cas de force majeure (telle que
            définie par la réglementation).
          </p>
          <p>
            En outre, Teddi ne saurait être tenue responsable des erreurs commises par le Membre
            dans l’indication de ses informations lors de la réservation de l’Offre sur le Site.
          </p>
          <p>
            En cas de non exécution des obligations résultant du contrat (ou de l'Offre), le Membre
            a la possibilité de se diriger directement à Teddi pour toute plainte ou réclamation
            afférente à la réalisation de l’Offre.
          </p>
          <p>9.1.3 – Maintenance et évolutions du Site.</p>
          <p>
            Teddi ne peut pas garantir un accès continu et sécurisé au Site car son bon
            fonctionnement peut être affecté par de nombreux facteurs que Teddi ne contrôle pas (en
            ce compris, sans que cette liste soit limitative : tous dysfonctionnements des services
            d'électricité et de télécommunications, toutes actions malveillantes perpétrées par des
            pirates informatiques et tous cas de force majeure).
          </p>
          <p>
            En conséquence, la responsabilité de Teddi ne pourra être recherchée du fait de tout
            retard ou perturbation pouvant affecter le Site, de tout virus ou logiciel malveillant,
            dysfonctionnement, bug, erreur ou inexactitude quelconque présent sur le Site.
          </p>
          <p>
            Teddi se réserve le droit de suspendre momentanément, sans indemnité ni préavis, l'accès
            au Site pour assurer des opérations de maintenance liées à l'évolution technologique ou
            nécessaires à la continuité du Service. Le Membre décharge Teddi de toute responsabilité
            à cet égard et renonce à toute réclamation et/ou procédure à son encontre de ce fait.
            Les interruptions temporaires du service seront, dans la mesure du possible, notifiées
            via le Site au minimum vingt-quatre heures avant qu'elles n'interviennent, sauf lorsque
            ces interruptions ont un caractère d'urgence.
          </p>
          <p>
            Teddi se réserve le droit de modifier ou de mettre à jour son matériel, son système
            d’exploitation et, d’une manière générale, tout ou partie du Site compte-tenu des
            évolutions de la technologie. Teddi se réserve le droit de mettre un terme définitif au
            Service, sans indemnité pour le Membre.
          </p>
          <p>9.2 – Responsabilité du Membre</p>
          <p>
            9.2.1 – Le Membre s’engage à collaborer de bonne foi avec Teddi et à lui fournir sans
            délai l’ensemble des informations pertinentes afin de délivrer le Service le plus
            performant possible. A cet égard, le Membre doit notamment disposer d’une adresse
            électronique valable et s’assurer de la bonne réception de ses courriers électroniques.
            S’il transmet des coordonnées erronées dans l’une des étapes de la réservation, Teddi ne
            saurait voir sa responsabilité engagée. Aucune légèreté ou négligence du Membre à cet
            égard ne sera imputée à Teddi. Par ailleurs, le Membre s'engage à actualiser dans les
            meilleurs délais les informations fournies à Teddi et sera seul responsable des
            conséquences éventuelles de l'absence d'actualisation de ces informations.
          </p>
          <p>
            9.2.2 – Le Membre s'engage à ne proposer à aucune autre personne l'accès au Site sous
            son identité ou son pseudonyme et supportera seul les conséquences de l'utilisation de
            son compte, même à son insu, par une personne utilisant son identifiant et son mot de
            passe.
          </p>
          <h2>ARTICLE 10 – Suspension à l’initiative de Teddi</h2>
          <p>
            Sans préjudice de tous dommages et intérêts que Teddi pourrait solliciter, Teddi se
            réserve le droit de suspendre l’accès au Service d'un Membre, de plein droit, sans
            préavis ni indemnité, en cas de : non respect par le Membre des présentes Conditions
            Générales (et notamment, sans que cette liste soit limitative, en cas de violation des
            droits de propriété intellectuelle de Teddi, connexions multiples simultanées à un même
            compte, fourniture de fausses informations lors de l’inscription au Service) ;
            agissements contraires aux intérêts commerciaux de Teddi.
          </p>
          <h2>ARTICLE 11 – Stipulations générales</h2>
          <p>11.1 – Indépendance des parties.</p>
          <p>
            Les parties reconnaissent et acceptent qu’elles ne pourront en aucun cas prendre un
            engagement au nom et/ou pour le compte l’une de l'autre. En outre, chacune des parties
            demeure seule responsable de ses actes, allégations, engagements, prestations.
          </p>
          <p>11.2 – Relations entre les parties.</p>
          <p>
            Les parties reconnaissent et acceptent que leur collaboration ne pourra en aucun cas
            être considérée comme établissant entre elles une société de fait, une société en
            participation ou tout autre situation entraînant entre elles une quelconque
            représentation réciproque ou solidarité à l’égard de leurs créanciers respectifs.
          </p>
          <p>11.3 – Autonomie des dispositions.</p>
          <p>
            Si l’une quelconque des dispositions des présentes Conditions Générales devait être
            déclarée nulle ou inapplicable, au regard d’une règle de droit en vigueur ou d’une
            décision judiciaire devenue définitive, elle sera modifiée en vue d’obtenir sa validité
            ou sera réputée non écrite, sans pour autant entraîner la nullité des Conditions
            Générales, ni altérer la validité de leurs autres dispositions.
          </p>
          <p>11.4 – Non renonciation.</p>
          <p>
            Le fait que l'une ou l'autre des parties ne revendique pas l'application de l'une
            quelconque des dispositions des Conditions Générales ou accepte son inexécution, que ce
            soit de manière permanente ou temporaire, ne pourra pas être interprété et ne
            constituera pas une renonciation par cette partie à son droit de faire appliquer
            ultérieurement cette disposition ou toute autre disposition des Conditions Générales.
          </p>
          <h2>ARTICLE 12 - Existence d’une difficulté</h2>
          <p>
            Pour toute difficulté ou réclamation, le Membre est invité à contacter le Service
            Clients de Teddi afin que les Parties tentent de trouver une solution amiable au
            différend existant soit :
          </p>
          <ul>
            <li>
              <p>
                Par courrier électronique à l’adresse : hello@teddi.co, ou,
              </p>
            </li>
            <li>
              Par courrier postal adressé à : 9 rue des Colonnes, 75002, Paris.
            </li>
          </ul>
          <p>
            Le Membre devra communiquer au Service Client les éléments justifiant son identité et
            les raisons des difficultés rencontrées.
          </p>
          <h2>ARTICLE 13 - Médiation pour le Membre consommateur</h2>
          <p>
            En cas d'échec de la tentative de solution amiable prévue à l’article 12 des présentes,
            le Membre consommateur est informé de la possibilité pour lui de soumettre le différend
            qui l'oppose à Teddi à un médiateur de la consommation qui tentera, en toute
            indépendance et impartialité, de rapprocher les parties en vue d'aboutir à une solution
            amiable.
          </p>
          <p>
            Le Membre consommateur dispose d’un délai d’un an à compter de sa réclamation écrite
            auprès de Teddi pour présenter sa demande au médiateur.
          </p>
          <p>
            Le site internet du médiateur de la consommation est :
            <a href="">…</a>
          </p>
          <p>Et ses coordonnées sont : <a href="">…</a></p>
          <p>
            Pour présenter sa demande de médiation, le Membre dispose d'un formulaire de réclamation
            accessible sur le site du médiateur précité.
          </p>
          <p>
            Les parties restent libres d'accepter ou de refuser le recours à la médiation ainsi que,
            en cas de recours à la médiation, d'accepter ou de refuser la solution proposée par le
            médiateur.
          </p>
          <p>
            La Commission Européenne met à disposition du consommateur, en cas de litige
            transfrontalier, une plateforme en ligne de résolution des différends à laquelle vous
            pouvez accéder en cliquant sur le lien suivant :
            <a
              href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home.show&amp;lng=FR"
              >https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home.show&amp;lng=FR</a
            >
          </p>
          <h2>ARTICLE 14 – Droit applicable et juridiction compétente</h2>
          <p>
            Les présentes Conditions Générales sont soumises au droit français.
          </p>
          <p>
            Le Membre peut saisir le Tribunal pour tout litige relatif à l’existence,
            l’interprétation, la conclusion, l’exécution ou la rupture du contrat.
          </p>
          <p>
            Dans l’hypothèse où le Membre est un consommateur, le Tribunal compétent sera défini
            selon les dispositions de droit commun.
          </p>
          <p>
            Dans l’hypothèse où le Membre est un professionnel, seul le Tribunal de commerce de
            Bobigny sera compétent pour connaître de tous litiges et la loi applicable sera la loi
            française.
          </p>
         
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/bottom/Footer.vue";

export default {
  metaInfo: {
    title: "Conditions générales d’utilisation",
    titleTemplate: "%s ← Teddi",
    meta: [
      { "http-equiv": "Content-Type", content: "text/html; charset=utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "L'utilisation de la plateforme Teddi nécessite la création d'un compte en ligne, vous êtes responsables de l'information personnelle que vous fournissez.",
      },
      {
        property: "og:title",
        content: "Conditions générales d’utilisation ← Teddi",
      },
      { property: "og:site_name", content: "Teddi" },
      { property: "og:type", content: "website" },
      {
        property: "og:url",
        content: "https://www.teddi.co/terms",
      },
      {
        property: "og:image",
        content: "https://www.teddi.co/assets/socials/fb-cover.jpg",
      },
      {
        property: "og:description",
        content:
          "L'utilisation de la plateforme Teddi nécessite la création d'un compte en ligne, vous êtes responsables de l'information personnelle que vous fournissez.",
      },
    ],
    link: [{ rel: "canonical", href: "https://www.teddi.co/terms" }],
  },
  components: {
    Footer,
  },
};
</script>

<style lang="scss" scoped>
h1,
h2 {
  text-align: left;
  font-weight: bold;
}
ul {
  text-align: left;
  li {
    list-style: disc;
  }
}
p {
  text-align: justify;
}
</style>
